import {ISSUE_VIEWER_CACHE_TTL_MS} from '@github-ui/preheat-issues-manager/issue-viewer-storage-key'
import {keepPreviousData, queryOptions} from '@github-ui/react-query'
import type {createServerPersistedQueryPersister} from '@github-ui/react-query-persister'
import {CreateBranchDialogFindRepoBranchesServerQuery as queryId} from '@github-ui/server-persisted-queries'
import type {CreateBranchDialogFindRepoBranchesServerQueryQuery as QueryData} from '@github-ui/server-persisted-queries/types/CreateBranchDialogFindRepoBranchesServerQuery'
import {reactFetchJSON} from '@github-ui/verified-fetch'

export function createBranchDialogBranchesQueryKey(owner: string, repo: string) {
  return ['issue-viewer', 'create-branch-dialog-branches', {owner, repo}] as const
}

// Built at module scope so the cached `queryFn` retains only these arguments, not a component's closure scope.
export function createBranchDialogBranchesQueryOptions(
  owner: string,
  repo: string,
  persister: ReturnType<typeof createServerPersistedQueryPersister>,
) {
  return queryOptions({
    queryKey: createBranchDialogBranchesQueryKey(owner, repo),
    queryFn: ({signal}) => fetchCreateBranchDialogBranches(owner, repo, signal),
    placeholderData: keepPreviousData,
    gcTime: ISSUE_VIEWER_CACHE_TTL_MS,
    persister,
  })
}

export async function fetchCreateBranchDialogBranches(
  owner: string,
  repo: string,
  signal?: AbortSignal,
): Promise<QueryData> {
  const url = `/${owner}/${repo}/create_branch_dialog_branches.json?queryId=${queryId}`
  const response = await reactFetchJSON(url, {signal})

  if (!response.ok) throw new Error(`Create branch dialog branches fetch failed (${response.status})`)

  const json = (await response.json()) as {data?: QueryData; errors?: unknown[]}
  if (!json.data) throw new Error('Create branch dialog branches query returned no data')

  return json.data
}
